export const miscTailHc = {
  maquetaCreateNav: {
    guidesAria: "Guides vidéo et aide",
    guidesTip: "Guides et aide",
    availabilityPricesTitle: "Disponibilité et Tarifs",
    hotelCalendarSubtitle: "Disponibilité et réservations par chambre",
    availabilityPricesSubtitle: "Prix, disponibilité et séjour minimum",
  },
  maquetaNav: {
    guidesAria: "Guides vidéo et aide",
    guidesTip: "Guides et aide",
    novedadesAria: "Nouveautés du système",
    novedadesTip: "Nouveautés",
    tourTip: "Nouveautés : visite guidée",
    tourAria: "Ouvrir la visite des nouveautés",
    backToPanel: "Retour au panneau",
    accountTitle: "Paramètres du compte",
    agentIaTitle: "Agent IA",
    directBookingsTitle: "Réservations directes",
    listingsTitle: "Paramètres des annonces",
  },
  navMovil: {
    menuTitle: "Menu",
    home: "Accueil",
    calendar: "Calendrier",
    reservations: "Réservations",
    checkins: "Check-ins",
    housekeeping: "Ménage",
    channels: "Canaux de réservation",
    settings: "Paramètres",
    settingsDesktopOnly: "Disponible uniquement dans la version bureau",
    experiences: "Expériences",
  },
  register: {
    terms: "Règlement",
    privacy: "Politique de confidentialité",
    loginError: "Erreur lors de la connexion.",
  },
  buttonSave: {
    savingRoom: "Enregistrement de la chambre...",
  },
  firstForm: {
    name: "Prénom",
    phone: "Téléphone",
  },
  final: {
    guestsRegistered: "Clients enregistrés",
    registrationsCompleted: "Enregistrements terminés",
    registrationTime: "Heure de l'enregistrement : ",
    shareRegistrationLink: "Partager le lien d'enregistrement",
  },
  scannerPdf417: {
    captureCode: "Capturer le code",
    focusInstruction: "Cadrez et capturez le code-barres de votre pièce d'identité",
  },
  configNotifications: {
    title: "Notifications",
    propertyLabel: "Propriété",
    phoneInstruction: "Saisissez le numéro de téléphone que vous souhaitez utiliser pour recevoir les notifications de demandes de service ou de check-ins effectués par les clients via WhatsApp",
    saveWhatsapp: "Enregistrer WhatsApp",
    editWhatsapp: "Modifier WhatsApp",
    configTitle: "Paramètres",
    serviceNotifications: "Notifications de services",
    checkinNotifications: "Notifications de check-in",
    active: "Activées",
    inactive: "Désactivées",
    whatsappRequired: "Vous devez saisir le WhatsApp",
    swalTitle: "WhatsApp pour les notifications de votre propriété",
    swalText: "Vous recevrez toutes les notifications des services demandés et des check-ins des clients ",
    cancel: "Annuler",
    whatsappAdded: "WhatsApp ajouté avec succès",
  },
  modalPoliceData: {
    headerSub: "Saisissez vos identifiants d'accès au système",
    closeAria: "Fermer",
    entityName: "Nom de l'entité",
    usernamePlaceholder: "Saisissez votre identifiant",
    passwordPlaceholder: "Saisissez votre mot de passe",
    hide: "Masquer",
    show: "Afficher",
    lessorExample: "Ex. : 12345",
    establishmentExample: "Ex. : 67890",
    saving: "Enregistrement…",
    listingNotFound: "L'annonce associée est introuvable.",
    saveFailed: "Impossible d'enregistrer SES Hospedajes.",
  },
  notificaciones: {
    title: "Notifications",
    propertyLabel: "Propriété",
    phoneInstruction: "Saisissez le numéro de téléphone que vous souhaitez utiliser pour recevoir les notifications de demandes de service ou de check-ins effectués par les clients via WhatsApp",
    saveWhatsapp: "Enregistrer WhatsApp",
    editWhatsapp: "Modifier WhatsApp",
    configTitle: "Paramètres",
    serviceNotifications: "Notifications de services",
    checkinNotifications: "Notifications de check-in",
    active: "Activées",
    inactive: "Désactivées",
    whatsappRequired: "Vous devez saisir le WhatsApp",
    swalTitle: "WhatsApp pour les notifications de votre propriété",
    swalText: "Vous recevrez toutes les notifications des services demandés et des check-ins des clients ",
    cancel: "Annuler",
    whatsappAdded: "WhatsApp ajouté avec succès",
  },
  admins: {
    listTitle: "Liste des managers",
    newManager: "Nouveau manager",
    today: "Aujourd'hui",
    thName: "Nom",
    thEmail: "E-mail",
    thRegistered: "Inscrit",
    edit: "Modifier",
    delete: "Supprimer",
    userLabel: "Identifiant",
    emailLabel: "E-mail",
    passwordLabel: "Mot de passe",
    cancel: "Annuler",
    save: "Enregistrer",
    createdOk: "Créé avec succès",
    requestError: "Erreur de requête",
    updatedOk: "Mis à jour avec succès",
    deletedOk: "Supprimé avec succès",
  },
};
